import { useCallback, useContext } from 'react';
import {
  CTA_GUARD_ACTION,
  CtaGuard,
  CtaGuardOutcome
} from '~/constants/common/ctaGuard';
import ModalContext from '~/context/vdp/ModalContext';
import { useGetIsPartnerVehicle } from '~/context/vdp/VehicleContext';
import { logInfo } from '~/utilities/loggers';

function useShowPartnerModal(): (onContinue: () => void) => () => void {
  const { setPartnerModalOpen } = useContext(ModalContext);
  const isPartnerVehicle = useGetIsPartnerVehicle();

  return useCallback(
    (onContinue: () => void) => () => {
      if (!isPartnerVehicle) {
        logInfo(CTA_GUARD_ACTION, {
          guard: CtaGuard.PartnerModal,
          isPartnerVehicle,
          outcome: CtaGuardOutcome.Passed
        });

        return onContinue();
      }

      logInfo(CTA_GUARD_ACTION, {
        guard: CtaGuard.PartnerModal,
        isPartnerVehicle,
        outcome: CtaGuardOutcome.Opened
      });

      setPartnerModalOpen(true, {
        onContinue: () => {
          logInfo(CTA_GUARD_ACTION, {
            guard: CtaGuard.PartnerModal,
            isPartnerVehicle,
            outcome: CtaGuardOutcome.Continued
          });

          setPartnerModalOpen(false);
          onContinue();
        }
      });
    },
    [isPartnerVehicle, setPartnerModalOpen]
  );
}

export default useShowPartnerModal;
